import { getIsValidString } from "@/utils/functions";

export type HomeDebtsBootstrapAction = "request" | "pull" | "reuse";

/**
 * Decides how home should bootstrap vehicle-debts.
 * - First entry (no requestId): POST /start.
 * - Return after PIN (or remount) with the same requestId: reuse debts or only poll status.
 *   Avoids a second POST that would discard the first consultation.
 */
export function resolveHomeDebtsBootstrap({
  requestId,
  isInitialMount,
  isLoading,
  hasDebts = false,
}: {
  requestId?: string;
  isInitialMount: boolean;
  isLoading: boolean;
  hasDebts?: boolean;
}): HomeDebtsBootstrapAction {
  const hasRequestId = getIsValidString(requestId);

  if (isInitialMount) {
    if (hasRequestId) {
      return hasDebts ? "reuse" : "pull";
    }
    return "request";
  }

  if (isLoading && hasRequestId) {
    return "pull";
  }

  return "request";
}
